import moment from 'moment';

const isIncludedToday = (startDate, endDate) => {
  const today = new Date();
  return moment(today).isBetween(startDate, endDate, undefined, '[]');
};

export { isIncludedToday };
